const FileUploadIcon = props => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="#4079F5"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6.75 12H11.25V7.5H14.25L9 2.25L3.75 7.5H6.75V12ZM3.75 13.5H14.25V15H3.75V13.5Z" />
  </svg>
)

export default FileUploadIcon
